module.exports = __webpack_public_path__ + "static/media/reimbursements.7db891b8.svg";